<template>
  <div class="csv-download">
    <el-button :type="type" @click="downloadClick" :disabled="isDisabled"
      ><i class="mdi mdi-download" :class="{ 'mr-0': !text }"></i>{{ text }}</el-button
    >
  </div>
</template>

<script lang="ts">
import Papa from 'papaparse'
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    download: Function,
    type: {
      default: 'default',
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    isOneTimeDownloadable: {
      default: false,
      type: Boolean
    },
    text: {
      default: 'CSVダウンロード',
      type: String
    }
  },
  data() {
    return {
      isDownloading: false
    }
  },
  computed: {
    isDisabled() {
      return this.disabled || this.isDownloading
    }
  },
  methods: {
    async downloadClick() {
      if (typeof this.download !== 'function') {
        return
      }
      if (this.isDisabled) {
        return
      }
      this.isDownloading = true
      let shouldResetDownloading = true
      try {
        const csvData = await this.download()
        if (!csvData) {
          return
        }
        if (csvData.error) {
          this.$notify({
            title: 'CSVダウンロードに失敗しました。',
            message: '恐れ入りますが、時間をおいて再度お試しください。',
            customClass: 'danger',
            duration: 5000
          })

          return
        }

        if (!csvData.data || !csvData.filename) {
          return
        }
        let filename = csvData.filename
        if (filename.indexOf('.csv') === -1) {
          filename = filename + '.csv'
        }

        const csvString = Papa.unparse(csvData.data)
        const blob = new Blob(['\ufeff', csvString])
        // msSaveBlob は IE 独自の API で、lib.dom の型にない
        const navigator = window.navigator as Navigator & {
          msSaveBlob?: (blob: Blob, defaultName: string) => boolean
        }
        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, filename)
        } else {
          const link = document.createElement('a')
          if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', filename)
            link.style.visibility = 'hidden'
            window.document.body.appendChild(link)
            link.click()
            window.document.body.removeChild(link)
            URL.revokeObjectURL(url)
          }
        }
        if (this.isOneTimeDownloadable) {
          shouldResetDownloading = false
        }
      } finally {
        if (shouldResetDownloading) {
          this.isDownloading = false
        }
      }
    }
  }
})
</script>
